var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { FilterFooter } from "../footer/Footer";
import { FilterExpandableButton } from "./Button";
var FilterExpandableFooter = /* @__PURE__ */ __name(function FilterExpandableFooter2(_ref) {
  var children = _ref.children, isExpanded = _ref.isExpanded, onClick = _ref.onClick, titleShowMore = _ref.titleShowMore, titleShowLess = _ref.titleShowLess;
  return /* @__PURE__ */ React.createElement(FilterFooter, null, children, /* @__PURE__ */ React.createElement(FilterExpandableButton, {
    isExpanded,
    onClick,
    titleShowMore,
    titleShowLess
  }));
}, "FilterExpandableFooter");
export {
  FilterExpandableFooter
};
